import {
  UPLOAD_STEPS,
} from "../models"
import { PhonePhotoPayload, UploadDocStore } from "types/store"
import {
  INIT_DOCUMENT_LOAD,
  RESET_UPLOAD_STORE,
  ADD_DOCUMENTS_TO_STORE,
  SUBMIT_DOCUMENT_ONGOING,
  SUBMIT_DOCUMENT_SUCCESS,
  SUBMIT_DOCUMENT_FAILURE,
  STATUS_RESOLVED,
  STATUS_REJECTED,
  STATUS_PENDING,
  RESET_UPLOAD_STATUS,
  QR_CODE_LINK_SUCCESS,
  UPLOAD_LINK_VIA_SMS_REQUEST_SUCCESS,
  NEW_DOCS_TRUE,
  GO_BACK_TO_SURVEY,
  ADD_DERMATO_PHOTO,
  ADD_PHONE_PHOTO,
  CLEAR_UPLOAD_LINK,
  HYDRATE_UPLOAD,
  MARK_PHONE_PHOTO_DOCS_PROCESSED,
  CLEAR_PROCESSED_PHONE_PHOTO_DOCS,
  SET_DERMATO_PATIENT_DETAILS,
  MARK_DERMATO_PATIENT_DETAILS_CONSUMED,
} from "./constants"
import { RESET_STORE } from "client/services/constants"


const MANAGER: Partial<UploadDocStore> = {
  steps: UPLOAD_STEPS,
  loading: false,
  documents: [],
  status: undefined,
  link: undefined,
  MobileUpload: { STATUS: undefined, NumberOfDocs: 0 },
  surveyLost: false,
  capturedDermatoPhotos: [],
  capturedPhonePhotos: [],
  phonePhotoKeys: [],
  processedPhonePhotoDocIds: [],
  dermatoPatientDetails: null,
  dermatoPatientDetailsId: null,
  dermatoPatientDetailsReceivedAt: null,
  dermatoPatientDetailsCreatedAt: null,
  dermatoPatientDetailsConsumedReceivedAt: null,
}



const reset = (manager: Partial<UploadDocStore>): Partial<UploadDocStore> => {
  return init({
    ...manager,
    capturedDermatoPhotos: [],
    capturedPhonePhotos: [],
    phonePhotoKeys: [],
    processedPhonePhotoDocIds: [],
    dermatoPatientDetails: null,
    dermatoPatientDetailsId: null,
    dermatoPatientDetailsReceivedAt: null,
    dermatoPatientDetailsCreatedAt: null,
    dermatoPatientDetailsConsumedReceivedAt: null,
  })
}


const init = (manager = MANAGER): Partial<UploadDocStore> => {
  localStorage.removeItem("NDC")
  localStorage.removeItem("RNDC")
  return {
    ...manager,
    processedPhonePhotoDocIds: manager.processedPhonePhotoDocIds ?? [],
  } as UploadDocStore
}

const Reducer = (state = init(MANAGER), action: any) 
:Partial<UploadDocStore> => {

  const documentReceived = (state :Partial<UploadDocStore>) => {
    return {
      ...state,
      documents: action.payload
    } as UploadDocStore
  }

  const SubmitDocumentRequested = (state :Partial<UploadDocStore>) => {
    return  {
      ...state,
      loading: true,
      status: STATUS_PENDING
    } as UploadDocStore
  }

  const SubmitDocumentSuccess = (state :Partial<UploadDocStore>) => {
    return  {
      ...state,
      loading: false,
      status: STATUS_RESOLVED
    } as UploadDocStore
  }

  const SubmitDocumentFail = (state :Partial<UploadDocStore>) => {
    return  {
      ...state,
      loading: false,
      status: STATUS_REJECTED
    } as UploadDocStore
  }

  const resetStatus = (state :Partial<UploadDocStore>) => {
    return  {
      ...state,
      loading: false,
      status: undefined,
      MobileUpload:  {STATUS:undefined ,
        NumberOfDocs: 0},
      link: undefined,
    } as UploadDocStore
  }

  const newDocUploadedFromMobile = (state :Partial<UploadDocStore>)=>{
    const mobileUpload = {STATUS:"finished" ,
    NumberOfDocs: action.payload}

    return  {
      ...state,
      MobileUpload: mobileUpload
    } as UploadDocStore
  }
  const serveQrcodeLink = (state :Partial<UploadDocStore>) => {
        return  {
          ...state,
          loading: false,
          link: action.payload
        } as UploadDocStore
  }

  const linkSendViaSMS = (state :Partial<UploadDocStore>) => {
    const NewLink = {...state.link, SendBySms :true}
    return  {
      ...state,
      loading: false,
      link: NewLink
    } as UploadDocStore
}

  switch (action.type) {
    case QR_CODE_LINK_SUCCESS :
      return serveQrcodeLink({...state })
    case UPLOAD_LINK_VIA_SMS_REQUEST_SUCCESS:
      return linkSendViaSMS({...state})
    case NEW_DOCS_TRUE :
      return newDocUploadedFromMobile({...state});
    case ADD_DOCUMENTS_TO_STORE:
        return documentReceived({ ...state })
    case SUBMIT_DOCUMENT_ONGOING:
       return SubmitDocumentRequested({ ...state }) ;
    case SUBMIT_DOCUMENT_SUCCESS:
        return SubmitDocumentSuccess({ ...state }) ;
    case SUBMIT_DOCUMENT_FAILURE :
        return SubmitDocumentFail({ ...state }) ;
    case INIT_DOCUMENT_LOAD:
      return init({ ...state } as Partial<UploadDocStore>)
    case RESET_STORE:
    case RESET_UPLOAD_STORE:
        return reset({ ...state } as Partial<UploadDocStore>)
    case RESET_UPLOAD_STATUS:
      return resetStatus({ ...state })
    case GO_BACK_TO_SURVEY:
      return  {
        ...state,
        surveyLost: true
      } as UploadDocStore
    case ADD_DERMATO_PHOTO:
      return {
        ...state,
        capturedDermatoPhotos: [...(state.capturedDermatoPhotos ?? []), action.payload],
      } as UploadDocStore
    case ADD_PHONE_PHOTO: {
      const { url, key } = action.payload as PhonePhotoPayload
      const existingKeys = state.phonePhotoKeys ?? []
      // Same document page already displayed (re-download after a link refresh
      // or a reload): keep the first one and drop the duplicate blob URL.
      if (existingKeys.includes(key)) {
        URL.revokeObjectURL(url)
        return state
      }
      return {
        ...state,
        capturedPhonePhotos: [...(state.capturedPhonePhotos ?? []), url],
        phonePhotoKeys: [...existingKeys, key],
      } as UploadDocStore
    }
    case MARK_PHONE_PHOTO_DOCS_PROCESSED: {
      const existing = state.processedPhonePhotoDocIds ?? []
      const incoming = (action.payload ?? []) as Array<string | number>
      const merged = [...existing]
      for (const id of incoming) {
        if (id != null && !merged.some((known) => String(known) === String(id))) {
          merged.push(id)
        }
      }
      return {
        ...state,
        processedPhonePhotoDocIds: merged,
      } as UploadDocStore
    }
    case CLEAR_PROCESSED_PHONE_PHOTO_DOCS:
      return {
        ...state,
        processedPhonePhotoDocIds: [],
      } as UploadDocStore
    case SET_DERMATO_PATIENT_DETAILS:
      return {
        ...state,
        dermatoPatientDetails: action.payload?.text ?? null,
        dermatoPatientDetailsId: action.payload?.id ?? null,
        dermatoPatientDetailsReceivedAt: action.payload?.receivedAt ?? null,
        dermatoPatientDetailsCreatedAt: action.payload?.createdAt ?? null,
      } as UploadDocStore
    case MARK_DERMATO_PATIENT_DETAILS_CONSUMED:
      return {
        ...state,
        dermatoPatientDetailsConsumedReceivedAt: action.payload ?? null,
      } as UploadDocStore
    case CLEAR_UPLOAD_LINK:
      return {
        ...state,
        link: undefined,
      } as UploadDocStore
    case HYDRATE_UPLOAD:
      return {
        ...state,
        documents: action.payload.documents || [],
        capturedDermatoPhotos: action.payload.capturedDermatoPhotos || [],
        capturedPhonePhotos: action.payload.capturedPhonePhotos || [],
        phonePhotoKeys: action.payload.phonePhotoKeys || [],
        processedPhonePhotoDocIds: action.payload.processedPhonePhotoDocIds || [],
      } as UploadDocStore
    default:
      return state
  }
}
  
export default Reducer